
interface NotificationPopUpProps {
  onClose: () => void;
}

const NotificationPopUp: React.FC<NotificationPopUpProps> = ({onClose}) => {
  return (
    <div
        className="notification-popup shadow rounded p-3 bg-white text-start"
        style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            zIndex: 1000,
            width: '400px',
            boxShadow: '0 0 10px rgba(0,0,0,0.1)',
            fontFamily: 'sans-serif',
        }}
    >
      <div className='border-bottom pb-2'>
              <h6 className="fw-bold mb-1">Notification</h6>
              <p className="text-muted mb-2" style={{ fontSize: '13px' }}>
                You have <strong>0 unread</strong> message
              </p>
             </div>

              <p style={{whiteSpace:'nowrap',maxWidth:'200px'}}></p>
              <p className="fw-semibold text-secondary small mt-2" style={{fontSize:'12px'}}>New</p>

              <div className="mb-3 mt-3 border-bottom pb-0" >
                <strong className="d-block" style={{fontSize:"13px"}}>New User Registered</strong>
                <p className="text-muted" style={{fontSize:'12px',padding:0}} >
                  A new user has signed up. Please review their information.
                </p>
              </div>

              <div className="mb-3 mt-3 border-bottom pb-0">
                <strong className="d-block" style={{fontSize:"13px"}} >New Booking Created</strong>
                <p className="text-muted" style={{fontSize:'12px',padding:0}} >
                  A new booking has been created. Booking ID: <b>908912</b>,
                  User: <b>rahul thakur</b>, Date: <b>12/02/2025</b>, Time:{' '}
                  <b>12.00AM</b>
                </p>
              </div>

              <div className="mb-3 mt-3 border-bottom pb-0">
                <strong className="d-block" style={{fontSize:"13px"}} >New User Registered</strong>
                <p className="text-muted" style={{fontSize:'12px',padding:0}} >
                  A new user has signed up. Please review their information.
                </p>
              </div>

              <div
                className="text-center text-danger fw-semibold mt-1"
                style={{ fontSize: '13px', cursor: 'pointer' }}
                onClick={onClose}
              >
                See All
              </div>
    </div>
  )
}

export default NotificationPopUp
